// useStyleVariables.js
import { computed } from 'vue'
import { usePortfolioStore } from '@/stores/portfolio'
import colors from "@/assets/json/portfolioColors.json"


// Space Scale — primary modular scale for all spatial values (sp1–sp12)
export function useSpaceScale() {
  const portfolioStore = usePortfolioStore();

  const space = computed(() => {
    const base = portfolioStore.fontSize;
    const mult = portfolioStore.fontMult;
    const step = (power) => Math.round(base * Math.pow(mult, power));

    return {
      sp1:  step(-4),   // ~5–7px   micro
      sp2:  step(-3),   // ~7–10px  tiny
      sp3:  step(-2),   // ~9–13px  xs
      sp4:  step(-1),   // ~13–14px sm
      sp5:  step(0),    // ~16–20px base (= body font size)
      sp6:  step(1),    // ~20–28px md
      sp7:  step(2),    // ~25–40px lg
      sp8:  step(3),    // ~31–57px xl
      sp9:  step(4),    // ~39–80px 2xl
      sp10: step(5),    // ~49–113px 3xl
      sp11: step(6),    // ~61–160px 4xl
      sp12: step(7),    // ~76–226px 5xl
    };
  });

  return { space }
}

// Text Scale — semantic font-size and line-height aliases into the space scale
export function useTextScale() {
  const { space } = useSpaceScale();

  const fontSize = computed(() => ({
    caption: space.value.sp3,
    small:   space.value.sp4,
    body:    space.value.sp5,
    h6:      space.value.sp6,
    h5:      space.value.sp7,
    h4:      space.value.sp8,
    h3:      space.value.sp9,
    h2:      space.value.sp10,
    h1:      space.value.sp11,
  }));

  const lineHeight = computed(() => ({
    body: space.value.sp6,
    h6:   space.value.sp7,
    h5:   space.value.sp8,
    h4:   space.value.sp9,
    h3:   space.value.sp10,
    h2:   space.value.sp11,
    h1:   space.value.sp12,
  }));

  return { fontSize, lineHeight }
}

// Colors
export function useSemanticColors() {
    const bgColors = computed(() => ({
        light: colors.neutral["1000"],
        lightTranslucent: colors.neutral["1000-70"],
        mediumTranslucent: colors.neutral["900-70"],
        dark: colors.neutral["000"],
        accent: colors.accent01["000"],
        accentTranslucent: colors.accent01["000-70"]
    }))

    const textColors = computed(() => ({
        bgLight: colors.neutral["000"],
        bgLightFaint: colors.neutral["800"],
        bgDark: colors.neutral["1000"],
        accent: colors.accent01["000"]
    }))

    const buttonColors = computed(() => ({
        neutralDark: colors.neutral["000"],
        neutralMedium: colors.neutral["900"],
        neutralLight: colors.neutral["1000"],
        hover: colors.accent02["000"],
        selected: colors.accent01["000"],
        accent: colors.accent01["000"],
        accentTranslucent: colors.accent01["000-70"]
    }))

    return {
        bgColors,
        textColors,
        buttonColors
    }
}
